import { useEffect, useRef } from 'react'

const useLatest = (variable) => {
    const ref = useRef(variable)

    useEffect(() => {
        ref.current = variable
    }, [variable])

    return ref
}

export default useLatest